import { get } from 'lodash';
import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { pricingFields, numberOfAccessPoints } from './businessWifiFieldNames';
import getPricingFromField from '../utils/getPricingFromField';

const customBusinessWifiPriceCalculators = {
  // Custom calculator for number of access points. For 1 access point there is no addition to the total
  // The addition to the total starts from the second addition of access point
  [numberOfAccessPoints]: (field, formFields, orderData) => {
    const pricing = getPricingFromField(
      formFields[field],
      orderData[field] || {}
    );
    const unitPriceValue = +get(
      formFields,
      `${numberOfAccessPoints}.monthlyPayment`,
      0
    );
    return {
      monthly: pricing.monthly - unitPriceValue,
      oneTime: 0,
      threeYearEasyPayment: 0,
      fiveYearEasyPayment: 0
    };
  }
};

export const getBusinessWifiTotals = (formFields, orderData) => {
  const customerInformationTotals = getTotalsForSetOfTotals(
    pricingFields,
    formFields,
    orderData,
    customBusinessWifiPriceCalculators
  );
  return customerInformationTotals;
};

export const getBusinessWifiPriceSelections = formFields => {
  const selectionsList = priceSelectionList(pricingFields, formFields);
  return selectionsList;
};
